import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import it from 'vuetify/es5/locale/it'
import en from 'vuetify/es5/locale/en'

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { it, en },
    current: 'it'
  },
});
